import api from "./api";

export interface WarehouseClientUser {
    userId: number;
    warehouseClientId: number,
}

export const createWarehouseClientUser = async (warehouseClient: WarehouseClientUser) => {
    try {
        await api.post(`/WarehouseClientUser`, warehouseClient);
    } catch (error) {
        console.error(`Erro ao criar WarehouseClientUser`, error);
        throw error;
    }
};

export const deleteWarehouseClientUser = async (id: number) => {
    try {
        await api.delete(`/WarehouseClientUser/${id}`);
        return true;
    } catch (error) {
        console.error(`Erro ao excluir WarehouseClientUser com ID ${id}:`, error);
        throw error;
    }
};
